import React, { useEffect, useState } from "react";
import Button from "../../components/common/ui/Button";
import {
  CheckBoxInput,
  TextInput,
  TimeInput,
} from "../../components/common/ui/Inputs";
import Table from "../../components/common/table/Table";
import { KISOKRestrict } from "../../validation/facilitySchema";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { useLocation } from "react-router-dom";
import fillAllimg from "../../assets/svg/fill-all.svg";
import deleteimg from "../../assets/svg/delete-button.svg";
import addrowimg from '../../assets/svg/btn_icons/create-btn-icon.svg';
import { DaysFlag } from "../../_helpers/enumerator";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import KioskRestrictIntervalTable from "../../components/common/table/KioskRestrictIntervalTable";

function LockKIOSKS({ errorMessage, setErrorMessage, generateRandomString }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const facilityID = location?.state ? location?.state?.facilityID : 0;
  //const [errorMessage, setErrorMessage] = useState({});

  // const [sunday, setSunday] = useState([]);
  // const [monday, setMonday] = useState([]);
  // const [tuesday, setTuesday] = useState([]);
  // const [wednesday, setWednesday] = useState([]);
  // const [thursday, setThursday] = useState([]);
  // const [friday, setFriday] = useState([]);
  // const [saturday, setSaturday] = useState([]);

  // const [sundayCheckbox, setSundayCheckbox] = useState(false);
  // const [mondayCheckbox, setMondayCheckbox] = useState(false);
  // const [tuesdayCheckbox, setTuesdayCheckbox] = useState(false);
  // const [wednesdayCheckbox, setWednesdayCheckbox] = useState(false);
  // const [thursdayCheckbox, setThursdayCheckbox] = useState(false);
  // const [fridayCheckbox, setFridayCheckbox] = useState(false);
  // const [saturdayCheckbox, setSaturdayCheckbox] = useState(false);

  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const DaysListData = useSelector((x) => x?.facility?.DaysListData);

  useEffect(() => {
    const facilityData = { ...facilityInformationData };
    const mergedArray = [
      ...DaysListData?.sunday,
      ...DaysListData?.monday,
      ...DaysListData?.tuesday,
      ...DaysListData?.wednesday,
      ...DaysListData?.thursday,
      ...DaysListData?.friday,
      ...DaysListData?.saturday,
    ];
    facilityData["Type_KioskRestrictInterval"] = mergedArray;
    dispatch(facilityAction.setFacilityData(facilityData));
  }, [DaysListData]);

  const getLockDetails = facilityInformationData?.getLockKIOSKDetails;

  useEffect(() => {
    if (
      getLockDetails &&
      (facilityID > 0 || facilityInformationData?.PrePopulate) &&
      facilityInformationData?.Type_KioskRestrictInterval
    ) {
      let UpdatedDaysListData = { ...DaysListData };
      const sundayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.sunday
        );
      const mondayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.monday
        );
      const tuesdayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.tuesday
        );
      const wednesdayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.wednesday
        );
      const thursdayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.thursday
        );
      const fridayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.friday
        );
      const saturdayData =
        facilityInformationData.Type_KioskRestrictInterval.filter(
          (item) => item?.WeekDayNumber === DaysFlag?.saturday
        );

      if (sundayData?.length > 0) {
        UpdatedDaysListData.sunday = sundayData;
        UpdatedDaysListData.sundayCheckbox = sundayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setSundayCheckbox(true);
      }
      else {
        UpdatedDaysListData.sunday = [];
        UpdatedDaysListData.sundayCheckbox = false;
        //setSundayCheckbox(false);
      }
      if (mondayData?.length > 0) {
        UpdatedDaysListData.monday = mondayData;
        UpdatedDaysListData.mondayCheckbox = mondayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setMondayCheckbox(true);
      }
      else {
        UpdatedDaysListData.monday = [];
        UpdatedDaysListData.mondayCheckbox = false;
        //setMondayCheckbox(false);
      }
      if (tuesdayData?.length > 0) {
        UpdatedDaysListData.tuesday = tuesdayData;
        UpdatedDaysListData.tuesdayCheckbox = tuesdayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setTuesdayCheckbox(true);
      }
      else {
        UpdatedDaysListData.tuesday = [];
        UpdatedDaysListData.tuesdayCheckbox = false;
        //setTuesdayCheckbox(false);
      }
      if (wednesdayData?.length > 0) {
        UpdatedDaysListData.wednesday = wednesdayData;
        UpdatedDaysListData.wednesdayCheckbox = wednesdayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setWednesdayCheckbox(true);
      }
      else {
        UpdatedDaysListData.wednesday = [];
        UpdatedDaysListData.wednesdayCheckbox = false;
        //setWednesdayCheckbox(false);
      }
      if (thursdayData?.length > 0) {
        UpdatedDaysListData.thursday = thursdayData;
        UpdatedDaysListData.thursdayCheckbox = thursdayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setThursdayCheckbox(true);
      }
      else {
        UpdatedDaysListData.thursday = [];
        UpdatedDaysListData.thursdayCheckbox = false;
        //setThursdayCheckbox(false);
      }
      if (fridayData?.length > 0) {
        UpdatedDaysListData.friday = fridayData;
        UpdatedDaysListData.fridayCheckbox = fridayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setFridayCheckbox(true);
      }
      else {
        UpdatedDaysListData.friday = [];
        UpdatedDaysListData.fridayCheckbox = false;
        //setFridayCheckbox(false);
      }
      if (saturdayData?.length > 0) {
        UpdatedDaysListData.saturday = saturdayData;
        UpdatedDaysListData.saturdayCheckbox = saturdayData?.filter((item) => item.ActiveStatus === 1)?.length > 0;;
        //setSaturdayCheckbox(true);
      }
      else {
        UpdatedDaysListData.saturday = [];
        UpdatedDaysListData.saturdayCheckbox = false;
        //setSaturdayCheckbox(false);
      }
      dispatch(facilityAction.setDaysListData(UpdatedDaysListData));
    }
  }, [getLockDetails]);


  useEffect(() => {
    if (
      (facilityID === 0) &&
      facilityInformationData?.Type_KioskRestrictInterval?.length === 0
    ) {

      dispatch(facilityAction.resetDaysListData());
    }
  }, [facilityInformationData?.Type_KioskRestrictInterval])


  const getColumns = (extraParam) => [
    {
      width: '220px',
      name: "From",
      selector: (row) => row.LockFromTime,
      sortable: false,
      cell: (row, i) => (
        <div className="w-100">
          <TimeInput
            handleChange={(e) => handleChange(e, row, i, extraParam)} // Pass extraParam here
            cName={"date-icon-1 LockFromTime" + extraParam + i}
            name={`kioskRestrictIntervalFillAll[${extraParam}].[${i}].LockFromTime`}
            value={
              extraParam === DaysFlag?.sunday
                ? DaysListData?.sunday?.[i]?.["LockFromTime"]
                : extraParam === DaysFlag?.monday
                  ? DaysListData?.monday?.[i]?.["LockFromTime"]
                  : extraParam === DaysFlag?.tuesday
                    ? DaysListData?.tuesday?.[i]?.["LockFromTime"]
                    : extraParam === DaysFlag?.wednesday
                      ? DaysListData?.wednesday?.[i]?.["LockFromTime"]
                      : extraParam === DaysFlag?.thursday
                        ? DaysListData?.thursday?.[i]?.["LockFromTime"]
                        : extraParam === DaysFlag?.friday
                          ? DaysListData?.friday?.[i]?.["LockFromTime"]
                          : extraParam === DaysFlag?.saturday
                            ? DaysListData?.saturday?.[i]?.["LockFromTime"]
                            : ""
            }
            placeholder={"02:00"}
            errorMessage={errorMessage}
          />
        </div>
      ),
    },
    {
      width: '220px',
      name: "To",
      selector: (row) => row.LockToTime,
      sortable: false,
      cell: (row, i) => (
        <div className="w-100">
          <TimeInput
            handleChange={(e) => handleChange(e, row, i, extraParam)} // Pass extraParam here
            cName={"date-icon-1 LockToTime" + extraParam + i}
            name={`kioskRestrictIntervalFillAll[${extraParam}].[${i}].LockToTime`}
            value={
              extraParam === DaysFlag?.sunday
                ? DaysListData?.sunday?.[i]?.["LockToTime"]
                : extraParam === DaysFlag?.monday
                  ? DaysListData?.monday?.[i]?.["LockToTime"]
                  : extraParam === DaysFlag?.tuesday
                    ? DaysListData?.tuesday?.[i]?.["LockToTime"]
                    : extraParam === DaysFlag?.wednesday
                      ? DaysListData?.wednesday?.[i]?.["LockToTime"]
                      : extraParam === DaysFlag?.thursday
                        ? DaysListData?.thursday?.[i]?.["LockToTime"]
                        : extraParam === DaysFlag?.friday
                          ? DaysListData?.friday?.[i]?.["LockToTime"]
                          : extraParam === DaysFlag?.saturday
                            ? DaysListData?.saturday?.[i]?.["LockToTime"]
                            : ""
            }
            errorMessage={errorMessage}
            placeholder={"03:24"}
          />
        </div>
      ),
    },
    {
      name: "For",
      selector: (row) => row.IntervalType,
      sortable: false,
      cell: (row, i) => (
        <TextInput
          placeholder="Enter for"
          handleChange={(e) => handleChange(e, row, i, extraParam)} // Pass extraParam here
          handleBlur={(e) => handleOnBlur(e, row, i, extraParam)} // Pass extraParam here
          cName={"IntervalType" + extraParam + i}
          name={`kioskRestrictIntervalFillAll[${extraParam}].[${i}].IntervalType`}
          id={`kioskRestrictIntervalFillAll[${extraParam}].[${i}].IntervalType`}
          value={
            extraParam === DaysFlag?.sunday
              ? DaysListData?.sunday?.[i]?.["IntervalType"]
              : extraParam === DaysFlag?.monday
                ? DaysListData?.monday?.[i]?.["IntervalType"]
                : extraParam === DaysFlag?.tuesday
                  ? DaysListData?.tuesday?.[i]?.["IntervalType"]
                  : extraParam === DaysFlag?.wednesday
                    ? DaysListData?.wednesday?.[i]?.["IntervalType"]
                    : extraParam === DaysFlag?.thursday
                      ? DaysListData?.thursday?.[i]?.["IntervalType"]
                      : extraParam === DaysFlag?.friday
                        ? DaysListData?.friday?.[i]?.["IntervalType"]
                        : extraParam === DaysFlag?.saturday
                          ? DaysListData?.saturday?.[i]?.["IntervalType"]
                          : ""
          }
          errorMessage={errorMessage}
          maxLength={50}
        />
      ),
    },
    {
      name: "Delete",
      sortable: false,
      cell: (row, i) =>
      (
        <>
          <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
            <CheckBoxInput
              label=""
              name={`Checkbox_${extraParam}_${i}`}
              handleClick={(e) => handleDeletelockKioskchange(e, extraParam, row.RandomID)}
              value={`${extraParam}_${i}`}
              checked={
                extraParam === DaysFlag?.sunday
                  ? DaysListData?.sundayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                  : extraParam === DaysFlag?.monday
                    ? DaysListData?.mondayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                    : extraParam === DaysFlag?.tuesday
                      ? DaysListData?.tuesdayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                      : extraParam === DaysFlag?.wednesday
                        ? DaysListData?.wednesdayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                        : extraParam === DaysFlag?.thursday
                          ? DaysListData?.thursdayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                          : extraParam === DaysFlag?.friday
                            ? DaysListData?.fridayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                            : extraParam === DaysFlag?.saturday
                              ? DaysListData?.saturdayDeleteChk?.some((data) => data[`Checkbox_${extraParam}_${i}`] === true) ?? false
                              : false
              }
            />
          </span>
        </>
      )
    },
  ];

  const DaysList = {
    1: DaysListData?.sunday,
    2: DaysListData?.monday,
    3: DaysListData?.tuesday,
    4: DaysListData?.wednesday,
    5: DaysListData?.thursday,
    6: DaysListData?.friday,
    7: DaysListData?.saturday,
  }

  const addRow = (day) => {
    const DaysChkMapping = {
      1: DaysListData?.sunday,
      2: DaysListData?.monday,
      3: DaysListData?.tuesday,
      4: DaysListData?.wednesday,
      5: DaysListData?.thursday,
      6: DaysListData?.friday,
      7: DaysListData?.saturday
    };
    DaysChkMapping[day]?.forEach((dayData, index) => {
      setErrorMessage((prev) => ({
        ...prev,
        [`kioskRestrictIntervalFillAll[${day}].[${index}].LockFromTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${index}].LockToTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${index}].IntervalType`]: "",
      }));
    });

    if (DaysList[day].length > 0) {
      const { error } = KISOKRestrict({ kioskRestrictIntervalFillAll: DaysList[day] });
      if (error?.details) {
        error?.details?.map((e) => {
          const { path } = e;
          const weekDayIndex = path[1];
          const field = path[2];
          const DaysChoosen = DaysList[day];
          const formattedPath = `kioskRestrictIntervalFillAll[${DaysChoosen[weekDayIndex]?.WeekDayNumber}].[${weekDayIndex}].${field}`;
          setErrorMessage((prev) => ({
            ...prev,
            [formattedPath]: e?.message,
          }));
          const elements = document.getElementsByClassName(formattedPath);
          if (elements?.length !== 0) {
            Array.from(elements).forEach((element) => {
              element.classList.add("input-error");
            });
          }
        });
        return;
      }
    }

    switch (day) {
      case 1:
        const sundayData = [...DaysListData?.sunday];
        sundayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.sunday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          sunday: sundayData
        }));

        if (sundayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(sundayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(sundayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(sundayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setSunday(sundayData);
        break;

      case 2:
        const mondayData = [...DaysListData?.monday];
        mondayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.monday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          monday: mondayData
        }));

        if (mondayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(mondayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(mondayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(mondayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setMonday(mondayData);
        break;

      case 3:
        const tuesdayData = [...DaysListData?.tuesday];
        tuesdayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.tuesday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          tuesday: tuesdayData
        }));

        if (tuesdayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(tuesdayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(tuesdayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(tuesdayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setTuesday(tuesdayData);
        break;

      case 4:
        const wednesdayData = [...DaysListData?.wednesday];
        wednesdayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.wednesday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          wednesday: wednesdayData
        }));

        if (wednesdayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(wednesdayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(wednesdayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(wednesdayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setWednesday(wednesdayData);
        break;

      case 5:
        const thursdayData = [...DaysListData?.thursday];
        thursdayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.thursday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          thursday: thursdayData
        }));

        if (thursdayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(thursdayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(thursdayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(thursdayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setThursday(thursdayData);
        break;

      case 6:
        const fridayData = [...DaysListData?.friday];
        fridayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.friday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          friday: fridayData
        }));

        if (fridayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(fridayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(fridayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(fridayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setFriday(fridayData);
        break;

      case 7:
        const saturdayData = [...DaysListData?.saturday];
        saturdayData?.push({
          RandomID: generateRandomString(10),
          FacilityID: 0,
          WeekDayNumber: DaysFlag?.saturday,
          LockFromTime: "",
          LockToTime: "",
          IntervalType: "",
          ActiveStatus: 1,
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          saturday: saturdayData
        }));

        if (saturdayData?.length > 0) {
          setErrorMessage((prev) => ({
            ...prev,
            [`kioskRestrictIntervalFillAll[${day}].[${(saturdayData?.length - 1)}].LockFromTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(saturdayData?.length - 1)}].LockToTime`]: "",
            [`kioskRestrictIntervalFillAll[${day}].[${(saturdayData?.length - 1)}].IntervalType`]: "",
          }));
        }
        //setSaturday(saturdayData);
        break;

      default:
        break;
    }
  };

  const deleteRow = (day) => {
    switch (day) {
      case 1:
        const sundayData = [...DaysListData?.sunday];
        const sundayDeleteChk = [...DaysListData?.sundayDeleteChk];
        const sundayDeleteRow = sundayData?.filter((data) => {
          if (!sundayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          sunday: sundayDeleteRow,
          sundayDeleteChk: []
        }));
        break;

      case 2:
        const mondayData = [...DaysListData?.monday];
        const mondayDeleteChk = [...DaysListData?.mondayDeleteChk];
        const mondayDeleteRow = mondayData?.filter((data) => {
          if (!mondayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          monday: mondayDeleteRow,
          mondayDeleteChk: []
        }));
        break;

      case 3:
        const tuesdayData = [...DaysListData?.tuesday];
        const tuesdayDeleteChk = [...DaysListData?.tuesdayDeleteChk];
        const tuesdayDeleteRow = tuesdayData?.filter((data) => {
          if (!tuesdayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          tuesday: tuesdayDeleteRow,
          tuesdayDeleteChk: []
        }));
        break;

      case 4:
        const wednesdayData = [...DaysListData?.wednesday];
        const wednesdayDeleteChk = [...DaysListData?.wednesdayDeleteChk];
        const wednesdayDeleteRow = wednesdayData?.filter((data) => {
          if (!wednesdayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          wednesday: wednesdayDeleteRow,
          wednesdayDeleteChk: []
        }));
        break;

      case 5:
        const thursdayData = [...DaysListData?.thursday];
        const thursdayDeleteChk = [...DaysListData?.thursdayDeleteChk];
        const thursdayDeleteRow = thursdayData?.filter((data) => {
          if (!thursdayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          thursday: thursdayDeleteRow,
          thursdayDeleteChk: []
        }));
        break;

      case 6:
        const fridayData = [...DaysListData?.friday];
        const fridayDeleteChk = [...DaysListData?.fridayDeleteChk];
        const fridayDeleteRow = fridayData?.filter((data) => {
          if (!fridayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          friday: fridayDeleteRow,
          fridayDeleteChk: []
        }));
        break;

      case 7:
        const saturdayData = [...DaysListData?.saturday];
        const saturdayDeleteChk = [...DaysListData?.saturdayDeleteChk];
        const saturdayDeleteRow = saturdayData?.filter((data) => {
          if (!saturdayDeleteChk.some(item => item.RandomID === data?.RandomID)) {
            return true;
          }
          return false;
        });
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          saturday: saturdayDeleteRow,
          saturdayDeleteChk: []
        }));
        break;

      default:
        break;
    }
  };

  const handleDeletelockKioskchange = (e, days, RandomID) => {
    const { name, checked } = e?.target;
    let UpdatedDaysListData = { ...DaysListData };

    switch (days) {
      case 1:
        if (checked) {
          UpdatedDaysListData.sundayDeleteChk = [
            ...UpdatedDaysListData.sundayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.sundayDeleteChk = UpdatedDaysListData.sundayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          sundayDeleteChk: UpdatedDaysListData.sundayDeleteChk,
        }));
        break;

      case 2:
        if (checked) {
          UpdatedDaysListData.mondayDeleteChk = [
            ...UpdatedDaysListData.mondayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.mondayDeleteChk = UpdatedDaysListData.mondayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          mondayDeleteChk: UpdatedDaysListData.mondayDeleteChk,
        }));
        break;

      case 3:
        if (checked) {
          UpdatedDaysListData.tuesdayDeleteChk = [
            ...UpdatedDaysListData.tuesdayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.tuesdayDeleteChk = UpdatedDaysListData.tuesdayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          tuesdayDeleteChk: UpdatedDaysListData.tuesdayDeleteChk,
        }));
        break;

      case 4:
        if (checked) {
          UpdatedDaysListData.wednesdayDeleteChk = [
            ...UpdatedDaysListData.wednesdayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.wednesdayDeleteChk = UpdatedDaysListData.wednesdayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          wednesdayDeleteChk: UpdatedDaysListData.wednesdayDeleteChk,
        }));
        break;

      case 5:
        if (checked) {
          UpdatedDaysListData.thursdayDeleteChk = [
            ...UpdatedDaysListData.thursdayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.thursdayDeleteChk = UpdatedDaysListData.thursdayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          thursdayDeleteChk: UpdatedDaysListData.thursdayDeleteChk,
        }));
        break;

      case 6:
        if (checked) {
          UpdatedDaysListData.fridayDeleteChk = [
            ...UpdatedDaysListData.fridayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.fridayDeleteChk = UpdatedDaysListData.fridayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          fridayDeleteChk: UpdatedDaysListData.fridayDeleteChk,
        }));
        break;

      case 7:
        if (checked) {
          UpdatedDaysListData.saturdayDeleteChk = [
            ...UpdatedDaysListData.saturdayDeleteChk,
            { [name]: checked, RandomID }
          ];
        } else {
          UpdatedDaysListData.saturdayDeleteChk = UpdatedDaysListData.saturdayDeleteChk.filter(
            (item) => item.RandomID !== RandomID
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          saturdayDeleteChk: UpdatedDaysListData.saturdayDeleteChk,
        }));
        break;

      default:
        break;
    }
  };

  const handleChange = (e, row, i, extraParam) => {
    const { name, value } = e?.target;
    const day = extraParam;
    const match = name.match(
      /kioskRestrictIntervalFillAll\[(\d+)\]\.\[(\d+)\]\.(\w+)/
    );
    switch (day) {
      case 1:
        if (match) {
          const fieldName = match[3];
          const updatedSundayData = [...DaysListData?.sunday];
          updatedSundayData[i] = {
            ...updatedSundayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            sunday: updatedSundayData
          }));
          //setSunday(updatedSundayData);
        }
        break;

      case 2:
        if (match) {
          const fieldName = match[3];
          const updatedMondayData = [...DaysListData?.monday];
          updatedMondayData[i] = {
            ...updatedMondayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            monday: updatedMondayData
          }));
          //setMonday(updatedMondayData);
        }
        break;

      case 3:
        if (match) {
          const fieldName = match[3];
          const updatedTuesdayData = [...DaysListData?.tuesday];
          updatedTuesdayData[i] = {
            ...updatedTuesdayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            tuesday: updatedTuesdayData
          }));
          //setTuesday(updatedTuesdayData);
        }
        break;

      case 4:
        if (match) {
          const fieldName = match[3];
          const updatedWednesdayData = [...DaysListData?.wednesday];
          updatedWednesdayData[i] = {
            ...updatedWednesdayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            wednesday: updatedWednesdayData
          }));
          //setWednesday(updatedWednesdayData);
        }
        break;

      case 5:
        if (match) {
          const fieldName = match[3];
          const updatedThursdayData = [...DaysListData?.thursday];
          updatedThursdayData[i] = {
            ...updatedThursdayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            thursday: updatedThursdayData
          }));
          //setThursday(updatedThursdayData);
        }
        break;

      case 6:
        if (match) {
          const fieldName = match[3];
          const updatedFridayData = [...DaysListData?.friday];
          updatedFridayData[i] = {
            ...updatedFridayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            friday: updatedFridayData
          }));
          //setFriday(updatedFridayData);
        }
        break;

      case 7:
        if (match) {
          const fieldName = match[3];
          const updatedsaturdayData = [...DaysListData?.saturday];
          updatedsaturdayData[i] = {
            ...updatedsaturdayData[i],
            [fieldName]: value,
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            saturday: updatedsaturdayData
          }));
          //setSaturday(updatedsaturdayData);
        }
        break;

      default:
        break;
    }
  };

  const handleOnBlur = (e, row, i, extraParam) => {
    const { name, value } = e?.target;
    const day = extraParam;
    const match = name.match(
      /kioskRestrictIntervalFillAll\[(\d+)\]\.\[(\d+)\]\.(\w+)/
    );
    switch (day) {
      case 1:
        if (match) {
          const fieldName = match[3];
          const updatedSundayData = [...DaysListData?.sunday];
          updatedSundayData[i] = {
            ...updatedSundayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            sunday: updatedSundayData
          }));
          //setSunday(updatedSundayData);
        }
        break;

      case 2:
        if (match) {
          const fieldName = match[3];
          const updatedMondayData = [...DaysListData?.monday];
          updatedMondayData[i] = {
            ...updatedMondayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            monday: updatedMondayData
          }));
          //setMonday(updatedMondayData);
        }
        break;

      case 3:
        if (match) {
          const fieldName = match[3];
          const updatedTuesdayData = [...DaysListData?.tuesday];
          updatedTuesdayData[i] = {
            ...updatedTuesdayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            tuesday: updatedTuesdayData
          }));
          //setTuesday(updatedTuesdayData);
        }
        break;

      case 4:
        if (match) {
          const fieldName = match[3];
          const updatedWednesdayData = [...DaysListData?.wednesday];
          updatedWednesdayData[i] = {
            ...updatedWednesdayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            wednesday: updatedWednesdayData
          }));
          //setWednesday(updatedWednesdayData);
        }
        break;

      case 5:
        if (match) {
          const fieldName = match[3];
          const updatedThursdayData = [...DaysListData?.thursday];
          updatedThursdayData[i] = {
            ...updatedThursdayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            thursday: updatedThursdayData
          }));
          //setThursday(updatedThursdayData);
        }
        break;

      case 6:
        if (match) {
          const fieldName = match[3];
          const updatedFridayData = [...DaysListData?.friday];
          updatedFridayData[i] = {
            ...updatedFridayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            friday: updatedFridayData
          }));
          //setFriday(updatedFridayData);
        }
        break;

      case 7:
        if (match) {
          const fieldName = match[3];
          const updatedsaturdayData = [...DaysListData?.saturday];
          updatedsaturdayData[i] = {
            ...updatedsaturdayData[i],
            [fieldName]: value ? value.trim() : "",
          };
          dispatch(facilityAction.setDaysListData({
            ...DaysListData,
            saturday: updatedsaturdayData
          }));
          //setSaturday(updatedsaturdayData);
        }
        break;

      default:
        break;
    }
  };

  const fillAll = () => {
    DaysListData?.sunday?.forEach((dayData, index) => {
      setErrorMessage((prev) => ({
        ...prev,
        [`kioskRestrictIntervalFillAll[${DaysFlag?.sunday}].[${index}].LockFromTime`]: "",
        [`kioskRestrictIntervalFillAll[${DaysFlag?.sunday}].[${index}].LockToTime`]: "",
        [`kioskRestrictIntervalFillAll[${DaysFlag?.sunday}].[${index}].IntervalType`]: "",
      }));
    });

    const { error } = KISOKRestrict({ kioskRestrictIntervalFillAll: DaysListData?.sunday });
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        const weekDayIndex = path[1];
        const field = path[2];

        const formattedPath = `kioskRestrictIntervalFillAll[${DaysListData?.sunday[weekDayIndex]?.WeekDayNumber}].[${weekDayIndex}].${field}`;
        setErrorMessage((prev) => ({
          ...prev,
          [formattedPath]: e?.message,
        }));
        const elements = document.getElementsByClassName(formattedPath);
        if (elements?.length !== 0) {
          Array.from(elements).forEach((element) => {
            element.classList.add("input-error");
          });
        }
      });
      return;
    } else {
      Popup({
        title: "Message",
        text: `This will copy Sunday’s time entries to all other days.`,
        icon: "info",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          const empTables = findEmptyDataTable();
          const updatedDaysListData = { ...DaysListData };
          empTables?.length > 0 &&
            empTables?.map((table) => {
              switch (table) {
                case 2:
                  // const mondayData = [...DaysListData?.monday];
                  const mondayData = [];
                  //setMondayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return mondayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.monday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.monday = mondayData;
                  updatedDaysListData.mondayCheckbox = true;
                  //setMonday(mondayData);
                  break;

                case 3:
                  // const tuesdayData = [...DaysListData?.tuesday];
                  const tuesdayData = [];
                  //setTuesdayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return tuesdayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.tuesday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.tuesday = tuesdayData;
                  updatedDaysListData.tuesdayCheckbox = true;

                  //setTuesday(tuesdayData);
                  break;

                case 4:
                  // const wednesdayData = [...DaysListData?.wednesday];
                  const wednesdayData = [];
                  //setWednesdayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return wednesdayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.wednesday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.wednesday = wednesdayData;
                  updatedDaysListData.wednesdayCheckbox = true;

                  //setWednesday(wednesdayData);
                  break;

                case 5:
                  // const thursdayData = [...DaysListData?.thursday];
                  const thursdayData = [];
                  //setThursdayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return thursdayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.thursday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.thursday = thursdayData;
                  updatedDaysListData.thursdayCheckbox = true;

                  //setThursday(thursdayData);
                  break;

                case 6:
                  // const fridayData = [...DaysListData?.friday];
                  const fridayData = [];
                  //setFridayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return fridayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.friday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.friday = fridayData;
                  updatedDaysListData.fridayCheckbox = true;

                  //setFriday(fridayData);
                  break;

                case 7:
                  // const saturdayData = [...DaysListData?.saturday];
                  const saturdayData = [];
                  //setSaturdayCheckbox(true);
                  DaysListData?.sunday?.map((data, i) => {
                    return saturdayData.push({
                      RandomID: generateRandomString(10),
                      FacilityID: 0,
                      WeekDayNumber: DaysFlag?.saturday,
                      LockFromTime: data?.LockFromTime,
                      LockToTime: data?.LockToTime,
                      IntervalType: data?.IntervalType,
                      ActiveStatus: 1,
                    });
                  });
                  updatedDaysListData.saturday = saturdayData;
                  updatedDaysListData.saturdayCheckbox = true;

                  //setSaturday(saturdayData);
                  break;

                default:
                  break;
              }
            });

          dispatch(facilityAction.setDaysListData(updatedDaysListData));
        }
      });
      //find empty table data
      //uppend data into table

    }
  };

  const findEmptyDataTable = () => {
    const empTables = [];
    if (DaysListData?.sunday?.length > 0) {
      empTables.push(DaysFlag?.sunday);
      empTables.push(DaysFlag?.monday);
      empTables.push(DaysFlag?.tuesday);
      empTables.push(DaysFlag?.wednesday);
      empTables.push(DaysFlag?.thursday);
      empTables.push(DaysFlag?.friday);
      empTables.push(DaysFlag?.saturday);
      return empTables;
    }
  };

  const DeleteTableRow = (days) => {
    let DeleteData = 0;
    const deleteChkMapping = {
      1: DaysListData?.sundayDeleteChk,
      2: DaysListData?.mondayDeleteChk,
      3: DaysListData?.tuesdayDeleteChk,
      4: DaysListData?.wednesdayDeleteChk,
      5: DaysListData?.thursdayDeleteChk,
      6: DaysListData?.fridayDeleteChk,
      7: DaysListData?.saturdayDeleteChk
    };

    if (deleteChkMapping[days]) {
      DeleteData = deleteChkMapping[days]?.length || 0;
    }
    if (DeleteData === 0) {
      Popup({
        title: "Message",
        text: `Please select any of the rows to delete.`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    } else {
      Popup({
        title: "Message",
        text: `Are you sure you want to delete the selected intervals?`,
        icon: "info",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => deleteRow(days),
      });
    }
  };


  const handleDaychange = (e, day) => {
    const { checked } = e?.target;
    const DaysChkMapping = {
      1: DaysListData?.sunday,
      2: DaysListData?.monday,
      3: DaysListData?.tuesday,
      4: DaysListData?.wednesday,
      5: DaysListData?.thursday,
      6: DaysListData?.friday,
      7: DaysListData?.saturday
    };
    DaysChkMapping[day]?.forEach((dayData, index) => {
      setErrorMessage((prev) => ({
        ...prev,
        [`kioskRestrictIntervalFillAll[${day}].[${index}].LockFromTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${index}].LockToTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${index}].IntervalType`]: "",
      }));
    });
    if (DaysChkMapping[day]?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [`kioskRestrictIntervalFillAll[${day}].[${0}].LockFromTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${0}].LockToTime`]: "",
        [`kioskRestrictIntervalFillAll[${day}].[${0}].IntervalType`]: "",
      }));
    }
    switch (day) {
      case 1:
        //setSundayCheckbox(checked);
        var updateSundayRow = [...DaysListData?.sunday];
        if (updateSundayRow.length === 0 && checked) {
          updateSundayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.sunday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        }
        else if (!checked) {
          if (
            updateSundayRow?.[0]?.LockFromTime === "" ||
            updateSundayRow?.[0]?.LockToTime === "" ||
            updateSundayRow?.[0]?.IntervalType === ""
          ) {
            updateSundayRow.pop();
          }
        }
        if (!checked && updateSundayRow?.length > 0) {
          updateSundayRow = updateSundayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateSundayRow?.length > 0) {
          updateSundayRow = updateSundayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }

        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          sunday: updateSundayRow,
          sundayCheckbox: checked
        }));
        //setSunday(updateSundayRow);
        break;
      case 2:
        //setMondayCheckbox(checked);
        var updateMondayRow = [...DaysListData?.monday];
        if (updateMondayRow.length === 0 && checked) {
          updateMondayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.monday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        }
        else if (!checked) {
          if (
            updateMondayRow?.[0]?.LockFromTime === "" ||
            updateMondayRow?.[0]?.LockToTime === "" ||
            updateMondayRow?.[0]?.IntervalType === ""
          ) {
            updateMondayRow.pop();
          }
        }
        if (!checked && updateMondayRow?.length > 0) {
          updateMondayRow = updateMondayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateMondayRow?.length > 0) {
          updateMondayRow = updateMondayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          monday: updateMondayRow,
          mondayCheckbox: checked
        }));
        //setMonday(updateMondayRow);
        break;

      case 3:
        //setTuesdayCheckbox(checked);
        var updateTuesdayRow = [...DaysListData?.tuesday];
        if (updateTuesdayRow?.length === 0 && checked) {
          updateTuesdayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.tuesday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        } else if (!checked) {
          if (
            updateTuesdayRow?.[0]?.LockFromTime === "" ||
            updateTuesdayRow?.[0]?.LockToTime === "" ||
            updateTuesdayRow?.[0]?.IntervalType === ""
          ) {
            updateTuesdayRow.pop();
          }
        }
        if (!checked && updateTuesdayRow?.length > 0) {
          updateTuesdayRow = updateTuesdayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateTuesdayRow?.length > 0) {
          updateTuesdayRow = updateTuesdayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          tuesday: updateTuesdayRow,
          tuesdayCheckbox: checked
        }));
        //setTuesday(updateTuesdayRow);
        break;

      case 4:
        //setWednesdayCheckbox(checked);
        var updateWednesdayRow = [...DaysListData?.wednesday];
        if (updateWednesdayRow?.length === 0 && checked) {
          updateWednesdayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.wednesday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        } else if (!checked) {
          if (
            updateWednesdayRow?.[0]?.LockFromTime === "" ||
            updateWednesdayRow?.[0]?.LockToTime === "" ||
            updateWednesdayRow?.[0]?.IntervalType === ""
          ) {
            updateWednesdayRow.pop();
          }
        }
        if (!checked && updateWednesdayRow?.length > 0) {
          updateWednesdayRow = updateWednesdayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateWednesdayRow?.length > 0) {
          updateWednesdayRow = updateWednesdayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          wednesday: updateWednesdayRow,
          wednesdayCheckbox: checked
        }));
        //setWednesday(updateWednesdayRow);
        break;
      case 5:
        //setThursdayCheckbox(checked);
        var updateThursdayRow = [...DaysListData?.thursday];
        if (updateThursdayRow?.length === 0 && checked) {
          updateThursdayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.thursday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        } else if (!checked) {
          if (
            updateThursdayRow?.[0]?.LockFromTime === "" ||
            updateThursdayRow?.[0]?.LockToTime === "" ||
            updateThursdayRow?.[0]?.IntervalType === ""
          ) {
            updateThursdayRow.pop();
          }
        }
        if (!checked && updateThursdayRow?.length > 0) {
          updateThursdayRow = updateThursdayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateThursdayRow?.length > 0) {
          updateThursdayRow = updateThursdayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          thursday: updateThursdayRow,
          thursdayCheckbox: checked
        }));
        //setThursday(updateThursdayRow);
        break;
      case 6:
        //setFridayCheckbox(checked);
        var updateFridayRow = [...DaysListData?.friday];
        if (updateFridayRow?.length === 0 && checked) {
          updateFridayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.friday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        } else if (!checked) {
          if (
            updateFridayRow?.[0]?.LockFromTime === "" ||
            updateFridayRow?.[0]?.LockToTime === "" ||
            updateFridayRow?.[0]?.IntervalType === ""
          ) {
            updateFridayRow.pop();
          }
        }
        if (!checked && updateFridayRow?.length > 0) {
          updateFridayRow = updateFridayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateFridayRow?.length > 0) {
          updateFridayRow = updateFridayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          friday: updateFridayRow,
          fridayCheckbox: checked
        }));
        //setFriday(updateFridayRow);
        break;

      case 7:
        //setSaturdayCheckbox(checked);
        var updateSaturdayRow = [...DaysListData?.saturday];
        if (updateSaturdayRow?.length === 0 && checked) {
          updateSaturdayRow.push({
            RandomID: generateRandomString(10),
            FacilityID: 0,
            WeekDayNumber: DaysFlag?.saturday,
            LockFromTime: "",
            LockToTime: "",
            IntervalType: "",
            ActiveStatus: 1,
          });
        } else if (!checked) {
          if (
            updateSaturdayRow?.[0]?.LockFromTime === "" ||
            updateSaturdayRow?.[0]?.LockToTime === "" ||
            updateSaturdayRow?.[0]?.IntervalType === ""
          ) {
            updateSaturdayRow.pop();
          }
        }
        if (!checked && updateSaturdayRow?.length > 0) {
          updateSaturdayRow = updateSaturdayRow.map(row =>
            ({ ...row, ActiveStatus: 0 })
          );
        }
        if (checked && updateSaturdayRow?.length > 0) {
          updateSaturdayRow = updateSaturdayRow.map(row =>
            ({ ...row, ActiveStatus: 1 })
          );
        }
        dispatch(facilityAction.setDaysListData({
          ...DaysListData,
          saturday: updateSaturdayRow,
          saturdayCheckbox: checked
        }));
        //setSaturday(updateSaturdayRow);
        break;

      default:
        break;
    }
  };

  return (
    <div className="mt-3 mb-3">
      <h4 className=" inner-header-bg text-color" style={{ cursor: "pointer" }} title="To lock the individual kiosks based on the given time for break or maintenance">
        <i className="fas fa-user-lock me-2"></i>Lock Individual Kiosks
      </h4>
      {/* <div className="mb-2 font-size-13">
        NOTE :- Request Form 27 - After submission to the administration, the
        inmate's form becomes invisible until the administration replies, after
        which it becomes visible again but is hidden once viewed. Select
        required forms and rename the form below
      </div>  */}

      <div className="accordion" id="accordion-sunday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingSunday">
              <button
                className={`accordion-button ${DaysListData?.sundayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={DaysListData?.sundayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.sundayCheckbox } }, DaysFlag?.sunday)
                }
              >
                <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Sunday"
                    name="sundayCheckbox"
                    // id="sundayCheckbox"
                    handleClick={(e) => handleDaychange(e, DaysFlag?.sunday)}
                    value="sundayCheckbox"
                    checked={DaysListData?.sundayCheckbox}
                  />
                </span>
              </button>
            </div>
            <div
              id="sunday-accordion"
              className={`accordion-collapse ${DaysListData?.sundayCheckbox ? "show" : "collapse"
                }`}
              aria-labelledby="headingSunday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {DaysListData?.sunday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                  <Button
                    label="Fill all"
                    status="btn-label"
                    imgsrc={fillAllimg}
                    type="button"
                    onClick={fillAll}
                  />
                </div>}
                {/* <Table columns={getColumns(DaysFlag?.sunday)} data={DaysListData?.sunday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.sunday}
                  data={DaysListData?.sunday}
                  deleteChk={DaysListData?.sundayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />

                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.sunday)}
                    />
                  </div>
                  {DaysListData?.sunday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.sunday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-monday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingMonday">
              <button
                className={`accordion-button ${DaysListData?.mondayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.mondayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.mondayCheckbox } }, DaysFlag.monday)
                }
              >
                <CheckBoxInput
                  label="Monday"
                  name="mondayCheckbox"
                  value="mondayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag.monday)}
                  checked={DaysListData?.mondayCheckbox}
                />
              </button>
            </div>
            <div
              id="monday-accordion"
              className={`accordion-collapse ${DaysListData?.mondayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.mondayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingMonday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* <Table columns={getColumns(DaysFlag?.monday)} data={DaysListData?.monday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.monday}
                  data={DaysListData?.monday}
                  deleteChk={DaysListData?.mondayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.monday)}
                    />
                  </div>
                  {DaysListData?.monday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.monday)}
                    />
                  </div>}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-tuesday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingTuesday">
              <button
                className={`accordion-button ${DaysListData?.tuesdayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.tuesdayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.tuesdayCheckbox } }, DaysFlag?.tuesday)
                }
              >
                <CheckBoxInput
                  label="Tuesday"
                  name="tuesdayCheckbox"
                  value="tuesdayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag?.tuesday)}
                  checked={DaysListData?.tuesdayCheckbox}
                />
              </button>
            </div>
            <div
              id="tuesday-accordion"
              className={`accordion-collapse ${DaysListData?.tuesdayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.tuesdayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingTuesday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* Optional Fill All Button */}
                {/* <div className="d-flex justify-content-end py-3">
            <Button label="Fill all" status="black" type="button" />
          </div> */}
                {/* <Table columns={getColumns(DaysFlag?.tuesday)} data={DaysListData?.tuesday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.tuesday}
                  data={DaysListData?.tuesday}
                  deleteChk={DaysListData?.tuesdayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.tuesday)}
                    /></div>
                  {DaysListData?.tuesday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.tuesday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-wednesday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingWednesday">
              <button
                className={`accordion-button ${DaysListData?.wednesdayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.wednesdayCheckbox}
                onClick={() =>
                  handleDaychange(
                    { target: { checked: !DaysListData?.wednesdayCheckbox } },
                    DaysFlag?.wednesday
                  )
                }
              >
                <CheckBoxInput
                  label="Wednesday"
                  name="wednesdayCheckbox"
                  value="wednesdayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag?.wednesday)}
                  checked={DaysListData?.wednesdayCheckbox}
                />
              </button>
            </div>
            <div
              id="wednesday-accordion"
              className={`accordion-collapse ${DaysListData?.wednesdayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.wednesdayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingWednesday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* Optional Fill All Button */}
                {/* <div className="d-flex justify-content-end py-3">
            <Button label="Fill all" status="black" type="button" />
          </div> */}
                {/* <Table columns={getColumns(DaysFlag?.wednesday)} data={DaysListData?.wednesday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.wednesday}
                  data={DaysListData?.wednesday}
                  deleteChk={DaysListData?.wednesdayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.wednesday)}
                    />
                  </div>
                  {DaysListData?.wednesday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.wednesday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-thursday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingThursday">
              <button
                className={`accordion-button ${DaysListData?.thursdayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.thursdayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.thursdayCheckbox } }, DaysFlag?.thursday)
                }
              >
                <CheckBoxInput
                  label="Thursday"
                  name="thursdayCheckbox"
                  value="thursdayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag?.thursday)}
                  checked={DaysListData?.thursdayCheckbox}
                />
              </button>
            </div>
            <div
              id="thursday-accordion"
              className={`accordion-collapse ${DaysListData?.thursdayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.thursdayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingThursday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* Optional Fill All Button */}
                {/* <div className="d-flex justify-content-end py-3">
            <Button label="Fill all" status="black" type="button" />
          </div> */}
                {/* <Table columns={getColumns(DaysFlag?.thursday)} data={DaysListData?.thursday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.thursday}
                  data={DaysListData?.thursday}
                  deleteChk={DaysListData?.thursdayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.thursday)}
                    />
                  </div>
                  {DaysListData?.thursday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.thursday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-friday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingFriday">
              <button
                className={`accordion-button ${DaysListData?.fridayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.fridayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.fridayCheckbox } }, DaysFlag?.friday)
                }
              >
                <CheckBoxInput
                  label="Friday"
                  name="fridayCheckbox"
                  value="fridayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag?.friday)}
                  checked={DaysListData?.fridayCheckbox}
                />
              </button>
            </div>
            <div
              id="friday-accordion"
              className={`accordion-collapse ${DaysListData?.fridayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.fridayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingFriday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* Optional Fill All Button */}
                {/* <div className="d-flex justify-content-end py-3">
            <Button label="Fill all" status="black" type="button" />
          </div> */}
                {/* <Table columns={getColumns(DaysFlag?.friday)} data={DaysListData?.friday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.friday}
                  data={DaysListData?.friday}
                  deleteChk={DaysListData?.fridayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.friday)}
                    />
                  </div>
                  {DaysListData?.friday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.friday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-saturday">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingSaturday">
              <button
                className={`accordion-button ${DaysListData?.saturdayCheckbox ? "" : "collapsed"
                  } text-white px-3 py-2 pointer-cursor border-grey`}
                type="button"
                aria-expanded={DaysListData?.saturdayCheckbox}
                onClick={() =>
                  handleDaychange({ target: { checked: !DaysListData?.saturdayCheckbox } }, DaysFlag?.saturday)
                }
              >
                <CheckBoxInput
                  label="Saturday"
                  name="saturdayCheckbox"
                  value="saturdayCheckbox"
                  handleClick={(e) => handleDaychange(e, DaysFlag?.saturday)}
                  checked={DaysListData?.saturdayCheckbox}
                />
              </button>
            </div>
            <div
              id="saturday-accordion"
              className={`accordion-collapse ${DaysListData?.saturdayCheckbox ? "show" : "collapse"
                }`}
              style={{
                maxHeight: DaysListData?.saturdayCheckbox ? "500px" : "0px",
                transition: "max-height 0.4s ease",
                overflow: "hidden",
              }}
              aria-labelledby="headingSaturday"
            >
              <div className="accordion-body text-white p-0 m-2">
                {/* Optional Fill All Button */}
                {/* <div className="d-flex justify-content-end py-3">
            <Button label="Fill all" status="black" type="button" />
          </div> */}
                {/* <Table columns={getColumns(DaysFlag?.saturday)} data={DaysListData?.saturday} /> */}
                <KioskRestrictIntervalTable
                  dayFlag={DaysFlag.saturday}
                  data={DaysListData?.saturday}
                  deleteChk={DaysListData?.saturdayDeleteChk}
                  DaysFlag={DaysFlag}
                  handleChange={handleChange}
                  handleOnBlur={handleOnBlur}
                  handleDeletelockKioskchange={handleDeletelockKioskchange}
                  errorMessage={errorMessage}
                />
                <div className="d-flex flex-wrap gap-2">
                  <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Add New Row"
                      type="button"
                      imgsrc={addrowimg}
                      onClick={() => addRow(DaysFlag?.saturday)}
                    />
                  </div>
                  {DaysListData?.saturday?.length > 0 && <div className="d-flex flex-wrap justify-content-end py-3">
                    <Button
                      status="btn-label"
                      label="Delete"
                      imgsrc={deleteimg}
                      type="button"
                      onClick={() => DeleteTableRow(DaysFlag?.saturday)}
                    />
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(LockKIOSKS);
